import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  PieChart, Pie, Sector, Cell,
} from 'recharts';

import { formatNumber } from 'utils/currencyFormat';

import styles from './PieChart.module.scss';

const COLORS = ['#165DFF', '#14C9C9', '#F7BA1E', '#722ED1', '#3491FA'];

const renderActiveShape = (props) => {
  const {
    cx, cy, innerRadius, outerRadius, startAngle, endAngle,
    fill,
  } = props;

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius - 3}
        outerRadius={outerRadius + 3}
        startAngle={startAngle + 2}
        endAngle={endAngle - 2}
        fill={fill}
      />
    </g>
  );
};

const getMaxIndex = (data) => {
  if (!data || !data.length) return 0;
  let maxIdx = 0;
  let maxVal = data[0].value;
  for (let i = 1; i < data.length; i += 1) {
    if (data[i].value > maxVal) {
      maxVal = data[i].value;
      maxIdx = i;
    }
  }
  return maxIdx;
};

function CustomActiveShapePieChart(props) {
  const { data } = props;
  const initialMaxIdx = React.useMemo(() => getMaxIndex(data), [data]);
  const [activeIndex, setActiveIndex] = useState(initialMaxIdx);

  React.useEffect(() => {
    setActiveIndex(initialMaxIdx);
  }, [initialMaxIdx]);

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };

  const totalValue = data.reduce((sum, item) => sum + item.value, 0);
  const percentageStr = totalValue > 0 && data[activeIndex]
    ? `${formatNumber(Number(((data[activeIndex].value / totalValue) * 100).toFixed(1)))}%`
    : '0%';

  return (
    <div className={styles.Components}>
      <PieChart width={200} height={180} className={styles.PieChartWrapper}>
        <Pie
          activeIndex={activeIndex}
          activeShape={renderActiveShape}
          data={data}
          cx={94}
          cy={84}
          innerRadius={65}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
          onMouseEnter={onPieEnter}
        >
          {data.map((item, index) => (
            <Cell
              key={`cell-${item.value}`}
              fill={item.color || COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>
      </PieChart>

      <div
        className={styles.Content}
      >
        <p className={styles.Label}>{data[activeIndex]?.name}</p>
        <p className={styles.Value}>
          {percentageStr}
        </p>
      </div>

    </div>

  );
}

CustomActiveShapePieChart.propTypes = {
  data: PropTypes.instanceOf(Array),
};

CustomActiveShapePieChart.defaultProps = {
  data: [],
};

export default React.memo(CustomActiveShapePieChart);
